export const translations = {
	"Category selection": {}
};
